import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { InterviewService } from '@App/interview.service';
import { DynamicFormComponent } from '@Components/form-fields/dynamic-form/dynamic-form.component';
import { InterviewSectionActionService } from '@Services';
import { SharedModule } from '@Shared/shared.module';

import * as _ from "lodash";

@Component({
    selector: 'interview-preview',
    // host: { 'class': 'd-flex flex-row flex-fill' },
    templateUrl: './interview-preview.component.html',
    styleUrls: ['./interview-preview.component.scss'],
    imports: [CommonModule, forwardRef(() => DynamicFormComponent)]
})
export class InterviewPreviewComponent implements OnInit {

    @Input() selectedSection;
    @Input() previewQuestions;
    @Input() selectedQuestion;
    @Input() expandAllQuestions;
    @Input() constantLists;

    constructor(public interviewSectionActionService: InterviewSectionActionService,
        public interviewService: InterviewService
    ){}

    ngOnInit(): void {
        const sectionSettings = this.interviewSectionActionService.getSectionSettings(this.selectedSection);

        this.interviewService.setSectionCondensedSetting(sectionSettings.isCondensedViewEnabled);
    }
}
